import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { DescriptionTextService } from './description-text.service';

type Theme = 'blue' | 'white';

@Component({
    selector: 'ca-description-text',
    templateUrl: './description-text.component.html',
    styleUrls: ['./description-text.component.scss'],
})
export class DescriptionTextComponent implements OnInit, OnDestroy {
    @Input() title: string = '';
    @Input() theme: Theme = 'white';

    @HostBinding('class.expanded') isExpanded: boolean = false;
    @HostBinding('class.theme-blue') isThemeBlue: boolean = this.theme === 'blue';

    constructor(private descriptionTextService: DescriptionTextService) {}

    ngOnInit(): void {
        this.isThemeBlue = this.theme === 'blue';
        this.descriptionTextService.isExpanded$.subscribe(state => (this.isExpanded = state));
        this.descriptionTextService.setHasDescriptionText(true);
    }

    ngOnDestroy(): void {
        this.descriptionTextService.setHasDescriptionText(false);
    }
}
